<div class="card stickyCard">
  <div class="card-header-white header-underline">
    <h6 class="white-header-text">
      {{ 'ADD_NIGHTOWL_SERVICE_CUSTOMER_ID' | translate }}
    </h6>
    <span class="float-right cursorPointer" (click)="closeForm()" style="margin-right: 15px; position: relative; top: -12px">
      <span class="fal fa-times"></span>
    </span>
  </div>
  <div class="card-body-white">
    <form [formGroup]="customerIdForm" (ngSubmit)="saveCustomerId()">
      <div class="form-group" formArrayName="customerIds">
        @for (ctrl of customerIdsArray.controls; track ctrl; let i = $index) {
          <div class="mb-3" [formGroupName]="i">
            <!-- Customer ID Group Card -->
            <div class="border rounded p-3 position-relative">
              <!-- Remove button at top right corner of the group - show if ID is enabled OR name is enabled -->
              @if ((!ctrl.get('id')?.disabled || !ctrl.get('name')?.disabled) && customerIdsArray.length > 1) {
                <span class="float-right cursorPointer"
                  style="margin-right: 0px; position: relative; top: -8px"
                  (click)="removeCustomerId(i)"
                  >
                  <span class="fal fa-times"></span>
                </span>
              }
              <div class="form-group mb-2">
                <label class="form-label"><strong>{{ 'NIGHTOWL_CUSTOMER_ID' | translate }}</strong></label>
                <input
                  formControlName="id"
                  type="text"
                  class="form-control"
                  style="font-size: 1.2em;"
                  placeholder="{{ 'NIGHTOWL_CUSTOMER_ID' | translate }}"
                  />
                </div>
                @if (shouldShowNameField()) {
                  <div class="form-group mb-0">
                    <label class="form-label"><strong>{{ 'NIGHTOWL_CUSTOMER_NAME' | translate }}</strong></label>
                    <input
                      formControlName="name"
                      type="text"
                      class="form-control"
                      style="font-size: 1.2em;"
                      placeholder="{{ 'NIGHTOWL_CUSTOMER_NAME' | translate }}"
                      />
                    </div>
                  }
                </div>
              </div>
            }
            <button type="button" class="btn btn-primary mt-2" [disabled]="isLastCustomerIncomplete" (click)="addCustomerId()">{{'ADD_ANOTHER' | translate}}</button>
          </div>
          <div class="form-group">
            @if (saveError) {
              <div class="alert alert-danger">
                {{'ERROR' |translate}}
              </div>
            }
            @if (duplicateIdError) {
              <div class="alert alert-danger">
                {{'DUPLICATE_IDS_ERROR' | translate}}
              </div>
            }
            @if (duplicateNameError) {
              <div class="alert alert-danger">
                {{'DUPLICATE_NAMES_ERROR' | translate}}
              </div>
            }
          </div>
          <div class="form-group">
            <button type="submit" [disabled]="!customerIdForm.valid" class="btn btn-outline-primary gray-bg mr-2">
              <span class="fal fa-save"></span> {{ 'SAVE' | translate }}
            </button>
            <button type="button" class="btn btn-outline-danger" (click)="closeForm()" name="cancel">
              <span class="fal fa-times"></span> {{ 'CANCEL' | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>